import { render } from "./BadgeOrderStatusForDistributor.vue?vue&type=template&id=3e06b52a&scoped=true"
import script from "./BadgeOrderStatusForDistributor.vue?vue&type=script&lang=js"
export * from "./BadgeOrderStatusForDistributor.vue?vue&type=script&lang=js"

import "./BadgeOrderStatusForDistributor.vue?vue&type=style&index=0&id=3e06b52a&scoped=true&lang=css"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e06b52a"]])

export default __exports__